import _defineProperty from 'babel-runtime/helpers/defineProperty';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _class, _temp;

var _templateObject = _taggedTemplateLiteral(['\n  background: #f5f8fa;\n  margin-left: 0;\n  margin-right: 0;\n  img {\n    display: block;\n    margin: 0 auto;\n    max-width: 100%;\n    width: auto;\n  }\n  figcaption {\n    background: #f5f8fa;\n    font-size: 14px;\n    line-height: 1.4;\n    padding: 10px;\n  }\n  &.align-', ' {\n    float: left;\n    margin-right: 1rem;\n  }\n  &.align-', ' {\n    float: right;\n    margin-left: 1rem;\n  }\n  &.size-', ' {\n    width: 50%;\n  }\n  &.size-', ' {\n    width: 100%;\n  }\n  &.size-', ' {\n    width: auto;\n    margin-left: calc(50% - 50vw);\n    margin-right: calc(50% - 50vw);\n  }\n'], ['\n  background: #f5f8fa;\n  margin-left: 0;\n  margin-right: 0;\n  img {\n    display: block;\n    margin: 0 auto;\n    max-width: 100%;\n    width: auto;\n  }\n  figcaption {\n    background: #f5f8fa;\n    font-size: 14px;\n    line-height: 1.4;\n    padding: 10px;\n  }\n  &.align-', ' {\n    float: left;\n    margin-right: 1rem;\n  }\n  &.align-', ' {\n    float: right;\n    margin-left: 1rem;\n  }\n  &.size-', ' {\n    width: 50%;\n  }\n  &.size-', ' {\n    width: 100%;\n  }\n  &.size-', ' {\n    width: auto;\n    margin-left: calc(50% - 50vw);\n    margin-right: calc(50% - 50vw);\n  }\n']);

import React, { Component } from 'react';
import classNames from 'classnames';
import styled from 'styled-components';
import filterProps from 'filter-invalid-dom-props';
import PropTypes from 'prop-types';
import { enumerate } from '../../lib/utils';

var SIZE = enumerate('MEDIUM', 'LARGE', 'EXTRALARGE');
var FLOAT = enumerate('NONE', 'LEFT', 'RIGHT');

var Image = styled.figure(_templateObject, FLOAT.LEFT, FLOAT.RIGHT, SIZE.MEDIUM, SIZE.LARGE, SIZE.EXTRALARGE);

var ImageCard = (_temp = _class = function (_Component) {
  _inherits(ImageCard, _Component);

  function ImageCard() {
    _classCallCheck(this, ImageCard);

    return _possibleConstructorReturn(this, (ImageCard.__proto__ || _Object$getPrototypeOf(ImageCard)).apply(this, arguments));
  }

  _createClass(ImageCard, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          size = _props.size,
          float = _props.float,
          className = _props.className,
          caption = _props.caption,
          onClick = _props.onClick,
          props = _objectWithoutProperties(_props, ['size', 'float', 'className', 'caption', 'onClick']);

      return React.createElement(
        Image,
        {
          onClick: onClick,
          className: classNames('size-' + size, className, _defineProperty({}, 'align-' + float, size === SIZE.MEDIUM))
        },
        React.createElement('img', filterProps(props)),
        !caption ? null : React.createElement(
          'figcaption',
          null,
          caption
        )
      );
    }
  }]);

  return ImageCard;
}(Component), _class.SIZE = SIZE, _class.FLOAT = FLOAT, _class.propTypes = {
  mediaId: PropTypes.string,
  url: PropTypes.string,
  src: PropTypes.string,
  large: PropTypes.string,
  alt: PropTypes.string,
  caption: PropTypes.string,
  size: PropTypes.number,
  float: PropTypes.number
}, _class.defaultProps = {
  mediaId: '',
  url: '',
  large: '',
  src: '',
  alt: '',
  caption: '',
  size: SIZE.LARGE,
  float: FLOAT.NONE
}, _temp);
export { ImageCard as default };